/**
 * Client → server logger for the attribution funnel.
 * Fire-and-forget; never block UX on logging.
 */
import { supabase } from "@/integrations/supabase/client";
import { isTrackingEnabled } from "@/lib/trackingEnvironment";

export type AttributionEvent =
  | "attribution.click_captured"
  | "attribution.cart_attributed"
  | "attribution.checkout_linked"
  | "attribution.fallback_used";

export interface AttributionLogInput {
  event_name: AttributionEvent;
  status?: "success" | "failed";
  event_id?: string;
  error_message?: string;
  payload_summary?: Record<string, unknown>;
}

export function logAttributionEvent(input: AttributionLogInput): void {
  if (typeof window === "undefined" || !isTrackingEnabled()) return;
  try {
    void supabase.functions.invoke("log-attribution-event", { body: input });
  } catch {
    // never throw from logging
  }
}
